import {IIUMLuxtagBase} from './app';

const iiumLuxtagBase = new IIUMLuxtagBase();

export default iiumLuxtagBase;
